import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-photo-for-list-form",
  templateUrl: "./product-photo-for-list-form.component.html",
  styleUrls: ["./product-photo-for-list-form.component.scss"],
})
export class ProductPhotoForListFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-photo-for-list-form/product-photo-for-list-form.component.ts